import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { reveal } from '../utils/motion';
const perspectives = [{
  outcome: 'The question changed from “how many did we hand out?” to “what did people do next?”',
  context: 'Illustrative brand-owner perspective · beverage launch team'
}, {
  outcome: 'We could see the consumer relationship behind every product trial—not just the distribution total.',
  context: 'Illustrative brand-owner perspective · beauty category team'
}, {
  outcome: 'The activation gave us both a memorable experience and a reason to invest in the next one.',
  context: 'Illustrative brand-owner perspective · challenger brand team'
}];
export function Testimonials() {
  const reduceMotion = useReducedMotion();
  return <section className="bg-paper px-5 py-24 md:px-10 md:py-32" aria-labelledby="perspectives-heading" data-id="element-806" data-mp="v8nar7dvcfh1">
      <div className="mx-auto max-w-shell" data-id="element-807" data-mp="h5y7ibcyv721">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end" data-id="element-808" data-mp="h4wtby0nm4g3">
          <div data-id="element-809" data-mp="m5b2xkhwlmg8">
            <p className="text-xs font-extrabold tracking-[0.16em] text-ink/55" data-id="element-810" data-mp="m5swg9d6lmkg">
              THE VALUE FOR BRAND OWNERS
            </p>
            <h2 id="perspectives-heading" className="mt-5 font-display text-4xl font-bold leading-[0.9] md:text-6xl" data-id="element-811" data-mp="7a4wwxit5nmw">
              Experiences that create confidence.
            </h2>
          </div>
          <p className="max-w-md text-sm font-bold leading-relaxed text-ink/60" data-id="element-812" data-mp="14vskqu176xmt">
            Placeholder perspectives to illustrate the outcome-led proof format.
            Replace with approved customer quotes and attribution.
          </p>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-3" data-id="element-813" data-mp="v3d0fq2fhwyr">
          {perspectives.map((perspective, index) => <motion.article key={perspective.outcome} {...reveal(reduceMotion, index)} className="flex min-h-[280px] flex-col border border-ink/15 p-7" data-id="element-814" data-mp="1nm0jz11s13xq" data-mpi={index}>
              <QuoteIcon size={22} className="text-signal" aria-hidden="true" data-id="element-815" data-mp="1sj5xvpgxl95k" />
              <p className="mt-10 font-display text-2xl font-bold leading-tight" data-id="element-816" data-mp="1ofrdkmlym6mb">
                “{perspective.outcome}”
              </p>
              <p className="mt-auto pt-8 text-xs font-extrabold uppercase tracking-[0.1em] text-ink/50" data-id="element-817" data-mp="1ej4ti01gjjlc">
                {perspective.context}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}